<template>
  <div class="p-20">
    <app-table
      ref="app_table_ref"
      :table-key="table_key"
      :table-props="{ 'max-height': '450px'}"
      :is-current-page="false"
      :page-size="2000"
      :table-list-data="formItem.assignSelection[advertiserId]"
    />
  </div>
</template>

<script>
export default {
  components: {
    'app-table': () => import('@/components/app-table'),
  },
  props: {
    /** 表单项配置 */
    formItem: {
      type: Object,
      required: true,
    },
    /** 广告主ID */
    advertiserId: {
      type: [Number, String],
      required: true,
    },
    /** 渠道号 */
    channelAlias: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      // 表头配置
      table_key: require('./model/table-key.js')(this),
    };
  },
  created() {
    this.initAssignSelection();
  },
  methods: {
    /**
     * 初始化分配数据
     * @returns {void}
     */
    initAssignSelection() {
      if (this.formItem.assignSelection[this.advertiserId]) {
        return;
      }
      Object.assign(this.formItem.assignSelection, {
        [this.advertiserId]: this.channelAlias.map(channel_alias => ({ channel_alias, unit_name: '' })),
      });
    },
  },
};
</script>
